export { Lightbox } from './lightbox.service';
export { LightboxConfig } from './lightbox-config.service';
export { LightboxEvent, LIGHTBOX_EVENT } from './lightbox-event.service';
export { LightboxModule } from './lightbox.module';
